import React, { createContext, useContext, useState, ReactNode } from 'react';
import styled from 'styled-components';

// TODO: FocusTrap component doesn't exist in configurator, needs to be implemented
// For now, using a simple div wrapper
const FocusTrap: React.FC<{ children: React.ReactNode }> = ({ children }) => <div>{children}</div>;

// Context for mobile dropdown state
interface MobileDropdownContextValue {
	isOpen: boolean;
	setIsOpen: (open: boolean) => void;
}

const MobileDropdownContext = createContext<MobileDropdownContextValue | undefined>(undefined);

export const MobileDropdownProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<MobileDropdownContext.Provider value={{ isOpen, setIsOpen }}>
			{children}
		</MobileDropdownContext.Provider>
	);
};

// Hook to check if mobile dropdown is open
export const useMobileFixedDropdopwnOpen = () => {
	const context = useContext(MobileDropdownContext);
	if (!context) {
		return false; // Fallback if provider not found
	}
	return context.isOpen;
};

interface FixedDropdownProps {
	onClose: () => void;
	children: React.ReactNode;
}

const Overlay = styled.div<{ $inert?: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: transparent;
	z-index: 9998;
`;

const Container = styled.div<{ $inert?: boolean }>`
	position: fixed;
	bottom: 85px;
	left: 8px;
	width: calc(100dvw - 16px);
	max-width: calc(100dvw - 16px);
	max-height: calc(100dvh - 100px);
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	background: white;
	z-index: 9999;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	padding: 16px;
`;

export const FixedDropdown: React.FC<FixedDropdownProps> = ({ onClose, children }) => {
	const context = useContext(MobileDropdownContext);

	// Set dropdown as open when mounted, closed when unmounted
	React.useEffect(() => {
		if (context) {
			context.setIsOpen(true);
			return () => {
				context.setIsOpen(false);
			};
		}
	}, [context]);

	return (
		<>
			<Overlay onClick={onClose} />
			<FocusTrap>
				<Container>{children}</Container>
			</FocusTrap>
		</>
	);
};
